import React, { Fragment } from 'react';
import { Form } from '../../../ui/universe';
import SafeMathJax from '../../../ui/SafeMathJax';

/**
 * EduAgent 渲染器 - 用于教育智能体结果
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.config - 结果配置
 * @param {boolean} props.isLoading - 是否加载中
 */
const EduAgentRenderer = ({ params, config, isLoading }) => {
  return (
    <>
      {params[config.firstField]?.map((mark, index) => (
        <Fragment key={`mark-${index}`}>
          {mark[config.value] && (
            <Form.Item label={mark[config.key]}>
              {!isLoading && (
                <SafeMathJax>
                  {mark[config.value]}
                </SafeMathJax>
              )}
            </Form.Item>
          )}
        </Fragment>
      ))}
    </>
  );
};

export default EduAgentRenderer;
